<script>
	import { flip } from "svelte/animate";
	import Spinner from "./spinner.svelte";
	import "bulma/css/bulma.css";

	let things = [];
	let colNames = [];
	let rowkeys = [];
	let time_slots = null;
	let time = null;

	async function getThings() {
		console.log("fetching");

		const res = await fetch(
			`https://api.jsonbin.io/v3/b/633c19d12b3499323bd2b91b/latest`
		);
		const json = await res.json();

		if (res.ok) {
			setTimeout(() => {
				things = json.record.slice(0, -1);
				time_slots = json.record.slice(-1)[0].time_fetch;
				console.log(things);
				//grab column names
				colNames = Object.keys(things[0]);
				var dt = new Date();
				time = toIsoString(dt);
				return true;
			}, 0 * Math.random());
		} else {
			throw new Error(text);
		}
	}

	function toIsoString(date) {
		var tzo = -date.getTimezoneOffset(),
			dif = tzo >= 0 ? "+" : "-",
			pad = function (num) {
				return (num < 10 ? "0" : "") + num;
			};

		return (
			date.getFullYear() +
			"-" +
			pad(date.getMonth() + 1) +
			"-" +
			pad(date.getDate()) +
			"T" +
			pad(date.getHours()) +
			":" +
			pad(date.getMinutes()) +
			":" +
			pad(date.getSeconds()) +
			dif +
			pad(Math.floor(Math.abs(tzo) / 60)) +
			":" +
			pad(Math.abs(tzo) % 60)
		);
	}

	let promise = getThings();

	function onDelete(id) {
		things = things.filter((t) => t.id != id);
	}

	function reload() {
		promise = getThings();
	}

	let sortBy = { col: "id", ascending: true };

	$: sort = (column) => {
		if (sortBy.col == column) {
			sortBy.ascending = !sortBy.ascending;
		} else {
			sortBy.col = column;
			sortBy.ascending = true;
		}

		// Modifier to sorting function for ascending or descending
		let sortModifier = sortBy.ascending ? 1 : -1;

		let sort = (a, b) =>
			a[column] < b[column]
				? -1 * sortModifier
				: a[column] > b[column]
				? 1 * sortModifier
				: 0;

		things = things.sort(sort);
	};
</script>

<main>
	<div class="box">
		<div class="block">
			<div class="columns is-vcentered">
				<div class="column is-2">
					<button on:click={reload} class="button is-primary"
						>Reload</button
					>
				</div>
				<div class="column is-4">
					<span class="tag is-info are-large">
						Last updated: {time}
					</span>
				</div>
				<div class="column" />
			</div>
		</div>
		<div class="block">
			{#await promise}
				<Spinner />
			{:then getThings}
				<div class="columns is-centered">
					<div class="column">
						<table class="table is-striped is-hoverable is-fullwidth">
							<thead>
								<tr>
									{#each colNames as col}
										<th on:click={sort(col)}
											>{col} &varr;</th
										>
									{/each}
								</tr>
							</thead>
							<tbody>
								{#each things as thing, index (thing.id)}
									<tr>
										{#each colNames as col, index}
											<td>{thing[col]}</td>
										{/each}
									</tr>
								{/each}
							</tbody>
						</table>
					</div>
				</div>
			{:catch error}
				<p style="color: red">{error.message}</p>
			{/await}
		</div>
		<div class="block">
			<div class="notification is-link has-text-centered">
				Slots fetched on: {time_slots}
			</div>
		</div>
	</div>
</main>

<style>
</style>
